import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';

/**
 * Generated class for the pos-element-person page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */



@Component({
  selector: 'page-pos-element-person',
  templateUrl: 'pos-element-person.html',
})
export class PosElementPersonPage {

  title: any;
  number_persons: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals) {
    this.title = this.navParams.get('title');
    this.number_persons = this.navParams.get('number_persons');
  }

  close() {
    this.viewCtrl.dismiss(undefined);
  }

  select(person) {
    this.viewCtrl.dismiss(person);
  }

  arrayOne(n: number): any[] {
    return Array(n);
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/pos/pos-element-person/pos-element-person.ts